import React, { useEffect, useState } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { ShopifySaleSendAttendeeDataToMongoDB2025Register } from "../api/AddToRegister";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Get_All_With_Sort_From_MongoDB } from "../../../api/Get_All_With_Sort_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
// material-ui

function ViewOrders() {
  const { logout } = StaffuseAuth();

  const [orders, setOrders] = useState([]);
  useEffect(() => {
    Get_All_With_Sort_From_MongoDB(
      "Shopify",
      "Orders_2025",
      { created_at: -1 },
      setOrders,
      logout
    );
  }, []);

  function handleAddToRegister(e, Order) {
    e.preventDefault();
    e.currentTarget.disabled = true;
    ShopifySaleSendAttendeeDataToMongoDB2025Register(Order, logout);
  }

  const [FilterEverything, setFilterEverything] = useState("");
  const handleFilterEverything = (e) => {
    setFilterEverything(e.target.value);
  };

  const ordersFiltered = orders.filter((Register) => {
    return FilterEverything.split(" ").every((word) => {
      return Object.values(Register).some((value) => {
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some((value2) => {
            return value2
              ?.toString()
              .toLowerCase()
              .includes(word.toLowerCase());
          });
        }
        return value?.toString().toLowerCase().includes(word.toLowerCase());
      });
    });
  });

  console.log(ordersFiltered);

  //let FilteredOrders equal to the orders that match the filter

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "95%",
            maxHeight: "800px",
            flexGrow: 1,
            p: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            View Order
          </Typography>
          <TextField
            id="FilterEverything"
            label="Filter Everything"
            variant="outlined"
            value={FilterEverything}
            onChange={handleFilterEverything}
            fullWidth
            sx={{ mt: 2, my: "auto", maxWidth: "200px" }}
          />
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    _id
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Created At
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Contact Email
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Order No
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Line Items
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Line 1 Discount Amount
                  </TableCell>
                  <TableCell
                    className="tableCellHeader" // Add this line to include the CSS class
                    align="left"
                    style={{
                      position: "sticky",
                      Top: 0,
                      zIndex: 1,
                      fontWeight: "bold", // Make Text bold
                      padding: "8px", // Adjust padding as needed To make cells smaller
                    }}
                  >
                    Manually Add To Register
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ordersFiltered.map((Order, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor:
                        Order?.MetaData?.Reserved === "Yes"
                          ? "rgba(0, 0, 139, 0.5)"
                          : Order?.MetaData?.Archived === "Yes"
                          ? "rgba(139, 0, 0, 0.5)"
                          : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order._id}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.created_at}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.contact_email}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.customer && Order.customer.first_name
                        ? Order.customer.first_name
                        : "fname"}{" "}
                      {Order.customer && Order.customer.last_name
                        ? Order.customer.last_name
                        : "lname"}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.name}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.line_items ? Order.line_items.length : 0}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {Order.line_items &&
                      Order.line_items &&
                      Order.line_items[0] &&
                      Order.line_items[0].discount_allocations &&
                      Order.line_items[0].discount_allocations[0] &&
                      Order.line_items[0].discount_allocations[0].amount
                        ? Order.line_items[0].discount_allocations[0].amount
                        : 0}
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {localStorage.getItem("Level") === "Admin" ? (
                        <button onClick={(e) => handleAddToRegister(e, Order)}>
                          Add
                        </button>
                      ) : (
                        "Sorry, Admins Only"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
}

export default ViewOrders;
